<template>
  <div id="TableForm">
    <dv-border-box-8>
      <div style="height:30%">
        <div style="height:60%;font-size: 25px;">按照国标《GB/T 13462-2008》,当前变电站按经济模式运行</div>
        <div style="height:40%">
          <table>
            <tr>
              <th>天度节省电费计算值:</th>
              <th>5000元</th>
            </tr>
          </table>
        </div>
      </div>

      <dv-scroll-board :config="config" style="height:70%" />
    </dv-border-box-8>
  </div>
</template>

<script>
export default {
  name: 'TableForm',
  data() {
    return {
      config: {
        header: ['开关编号', '状态'],
        data: [
          ['001A', '断开'],
          ['002A', '闭合'],
          ['003A', '闭合']
        ],
        index: true,
        columnWidth: [50, 170, 300],
        align: ['center'],
        rowNum: 3,
        headerHeight: 35,
        headerBGC: '#061338',
        oddRowBGC: 'rgba(0, 44, 81, 0.8)',
        evenRowBGC: 'rgba(10, 29, 50, 0.8)'
      }
    };
  }
};
</script>

<style lang="less" scope>
#TableForm {
  position: relative;
  width: 95%;
  height: 50%;
  background-color: rgba(6, 30, 93, 0.5);
  // border-top: 2px solid rgba(1, 153, 209, 0.5);
  box-sizing: border-box;
}
</style>
